import type { FormSection } from 'src/types/form-config.types';

// ----------------------------------------------------------------------

export const contactFormFields = {
  firstName: {
    name: 'firstName',
    label: 'FIRST_NAME',
    type: 'text' as const,
    placeholder: 'ENTER_FIRST_NAME',
  },
  lastName: {
    name: 'lastName',
    label: 'LAST_NAME',
    type: 'text' as const,
    placeholder: 'ENTER_LAST_NAME',
    required: true,
  },
  email: {
    name: 'email',
    label: 'EMAIL',
    type: 'email' as const,
    placeholder: 'ENTER_EMAIL',
    required: false,
  },
  phone: {
    name: 'phone',
    label: 'CONTACT_NUM',
    type: 'phone' as const,
    placeholder: 'ENTER_PHONE_NUM',
    required: false,
  },
  address: {
    name: 'address',
    label: 'ADDRESS',
    type: 'text' as const,
    placeholder: 'ENTER_ADDRESS',
  },
  city: {
    name: 'city',
    label: 'CITY',
    type: 'text' as const,
    placeholder: 'ENTER_CITY',
  },
  nationalId: {
    name: 'nationalId',
    label: 'NATIONAL_ID',
    type: 'text' as const,
    placeholder: 'ENTER_NATIONAL_ID',
  },
  country: {
    name: 'country',
    label: 'COUNTRY',
    type: 'text' as const,
    placeholder: 'ENTER_COUNTRY',
  },
  lifecycleStage: { name: 'lifecycleStage', label: 'LIFECYCLE_STAGE', type: 'select' as const },
  assignUsers: {
    name: 'assignUsers',
    label: 'ASSIGNED_TO',
    type: 'multiAssign' as const,
    placeholder: 'SELECT_RECIPIENTS',
    required: true,
  },
  companyId: {
    name: 'companyId',
    label: 'ACCOUNT_NAME',
    type: 'custom' as const,
    placeholder: 'SEARCH_ACCOUNT',
    required: false,
  },
};

export const contactFormConfig: FormSection[] = [
  {
    title: 'CONTACT_DETAILS',
    fields: [
      { ...contactFormFields.firstName, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.lastName, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.email, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.phone, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.address, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.city, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.nationalId, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.country, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.lifecycleStage, gridSize: { xs: 12, md: 12 } },
    ],
  },
  {
    title: 'ASSIGNMENT_AND_ACCOUNT',
    fields: [
      { ...contactFormFields.assignUsers, gridSize: { xs: 12, md: 12 } },
      { ...contactFormFields.companyId, gridSize: { xs: 12, md: 12 } },
    ],
  },
];
